import { Button } from '@hqo/ui-atoms';
import { ArrowLeft } from 'lucide-react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { CreateVisitFormV2 } from 'components/create-visit-form-v2';
import { useIsDesktopHost } from 'hooks/use-host-info.hook';
import { useNativeHistoryHeader } from 'hooks/use-native-history-header.hook';

export const EditVisitPageV2 = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const handleCancel = useCallback(() => {
    navigate('../view');
  }, [navigate]);
  const isDesktop = useIsDesktopHost();

  // The native header carries the way back on mobile; the in-app one would sit directly under it.
  useNativeHistoryHeader(!isDesktop);

  return (
    <div className="h-full bg-white">
      <div className="bg-white">
        <div className="px-1 sm:px-6 lg:px-12 py-3 sm:py-6 flex justify-center">
          <div className="w-full max-w-6xl">
            {isDesktop && (
              <Button
                variant="ghost"
                onClick={handleCancel}
                className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-3 sm:mb-4 transition-colors"
              >
                <ArrowLeft className="h-4 w-4" />
                <span className="text-sm font-medium">
                  {formatMessage({ id: 'header.title', defaultMessage: 'Visitor Management' })}
                </span>
              </Button>
            )}

            <div className="flex items-center justify-between px-6 sm:px-0">
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-gray-900">
                {formatMessage({ id: 'labels.editVisit', defaultMessage: 'Edit visit' })}
              </h1>
              <Button variant="outline" onClick={handleCancel} className="hidden sm:block">
                {formatMessage({ id: 'buttons.cancel', defaultMessage: 'Cancel' })}
              </Button>
            </div>

            <div className="mt-6 sm:mt-8 px-6 sm:px-0">
              <CreateVisitFormV2 />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
